import Api from './Api';

const all = (payload) => {
    const path = '/site-ownerships';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/site-ownership/update',
        method: 'PUT',
        data: payload
    });
};

export default {
    all,
    update
};
